import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { useParams } from 'react-router-dom';
import {
  getPositions,
  getPurchaseApplicationMaterials,
  loadPurchaseApplication,
  loadPurchaseApplicationHistory,
} from './api';

export const path = '/purchase-application/:applicationNumber';
export const getPath = (applicationNumber: string) => `/purchase-application/${applicationNumber}`;

const PagePurchaseAppliaction: React.FC = (props) => {
  const { applicationNumber } = useParams<{ applicationNumber: string }>();

  const PurchaseAppliaction = Loadable.Map({
    loader: {
      page: () => import('./page'),
      positions: getPositions,
      materials: getPurchaseApplicationMaterials,
      purchaseApplication: () => loadPurchaseApplication(applicationNumber),
      purchaseApplicationHistory: () => loadPurchaseApplicationHistory(applicationNumber),
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <PurchaseAppliaction {...props} />;
};

export default PagePurchaseAppliaction;
